import styled from 'styled-components';

export const HeaderTitle = styled.div`
    font-size: var(--text-size-medium);
    color: var(--default-text-color);
    font-weight: 600;
    margin: 0px;
    padding: 0px;
`;
